import React, { Component } from "react";
import axios from "axios";
import { TableCell, TableContainer, TableRow, Paper } from "@mui/material";

import { displayStoredDate, formatAmount } from "../../helper";
import JobForm from "../../Components/JobForm";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import StatusChip from "./shared/StatusChip";
import OwnEntityField from '../../Components/OwnEntityField';
import { defaultOwnId } from '../../helper/identity';

const OWN_SCREEN = '/admin/job-request';


function isJson(string) {
    try {
        JSON.parse(string); // Attempt to parse the string
        return true; // If successful, it's valid JSON
    } catch (e) {
        return false; // If an error occurs, it's not valid JSON
    }
}


const chipStatus = {
    "Available": "info",
    "Finish": "success",
    "In Process": "warning",
    "Completed": "neutral",
    "Refund": "error",
    "Request": "info",
}


class JobRequest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The working shop (Phase 2): the list shows it and new records are saved to it.
            OWN_ID: defaultOwnId('shop', OWN_SCREEN),
            RequestList: [],
            openModal: false,
            filteredListData: "",
            eligibleFor: 'Available'
        }
        this.gridRef = React.createRef(null);
    }
    // componentDidMount() {
    //     this.getAvailableRequests()
    // }

    async getAvailableRequests(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_SHOP: this.ownId(),
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/getAvailableRequet.php`, formData).then((response) => {
            let repairData = [];
            if (response.data.success === 1) {
                let myRecord = []
                let JobRecord = response.data.data
                for (let i = 0; i < JobRecord.length; i++) {
                    const myEle = JobRecord[i]
                    myEle.PC_REP_BRAND = isJson(myEle.PC_REP_BRAND) ? JSON.parse(myEle.PC_REP_BRAND) : myEle.PC_REP_BRAND;
                    myEle.PC_REP_MODEL = isJson(myEle.PC_REP_MODEL) ? JSON.parse(myEle.PC_REP_MODEL) : myEle.PC_REP_MODEL;
                    myEle.PC_REP_LIST = isJson(myEle.PC_REP_LIST) ? JSON.parse(myEle.PC_REP_LIST) : myEle.PC_REP_LIST;
                    myEle.PC_REP_TYPE = isJson(myEle.PC_REP_TYPE) ? JSON.parse(myEle.PC_REP_TYPE) : myEle.PC_REP_TYPE;
                    myEle.PC_REP_NOTES = isJson(myEle.PC_REP_NOTES) ? JSON.parse(myEle.PC_REP_NOTES) : myEle.PC_REP_NOTES;
                    myRecord.push(myEle)
                }

                repairData = myRecord
                pagination.totalItems = parseInt(response.data.Page_count[0]['TOTAL_PAGE_COUNT'])
                pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)

                this.gridRef.current?.setPaginationData(pagination)
            }
            this.setState({ RequestList: repairData })
        }).catch((error) => {
            console.error('error', error);
            this.setState({ RequestList: [] })
        }).finally(() => {
            this.props.toggleLoader(false);
        })
    }

    /* ── Working shop (Phase 2, 2026-11-02): a user with several shops picks it at the top. ── */
    ownId() {
        return this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id) }, () => this.getAvailableRequests());
    }


    handleOpenOnlineBooking(historyRow) {
        // let { RequestList } = this.state
        let filteredListData = historyRow
        this.setState({ filteredListData, openModal: true })
    }

    handleClose() {
        this.getAvailableRequests()
        this.setState({ openModal: false })
    }


    render() {
        return (
            <div>
                <OwnEntityField compact kind={'shop'} screen={OWN_SCREEN} value={this.ownId()} onChange={this.handleOwnChange.bind(this)} />
                <PhoneClinicGrid
                    ref={this.gridRef}
                    title="AVAILABLE REQUEST"
                    getData={this.getAvailableRequests.bind(this)}
                    isEditable={true}
                    tableHeadData={[
                        { label: "DATE", isHidden: false },
                        { label: "BARCODE", isHidden: false },
                        { label: "CUSTOMER", isHidden: false },
                        { label: "DEVICE", isHidden: false },
                        { label: "IMEI / SERIAL NO", isHidden: false },
                        { label: "STATUS", isHidden: false },
                        { label: "TOTAL PRICE", isHidden: false, align: 'right' },
                    ]}
                >
                    {/* One row per record (flattened 2026-10-22). Labels follow the sale/purchase standard (DEVICE,
                        TOTAL PRICE); BARCODE and IMEI / SERIAL NO stay because a repair job is found by them. */}
                    {this.state.RequestList.map((row, idx) => (
                        <TableRow key={idx}>
                            <TableCell>{displayStoredDate(row.PC_REP_CREATED_DATE)}</TableCell>
                            <TableCell>{row.PC_REP_BARCODE}</TableCell>
                            <TableCell>{row.PC_CUST_FR_NAME + ' ' + row.PC_CUST_LT_NAME || 'N/A'}</TableCell>
                            <TableCell>{row.PC_REP_BRAND.value || 'N/A'}</TableCell>
                            <TableCell>{row.PC_REP_IMSR || 'N/A'}</TableCell>
                            <TableCell><StatusChip label={row.PC_REP_STATUS} type={chipStatus[row.PC_REP_STATUS]} /></TableCell>
                            <TableCell align="right"><strong>£ {formatAmount(row.PC_REP_TOTAL_COST)}</strong></TableCell>
                            <TableCell align='center'>
                                <RowActions actions={[
                                    { type: 'edit', onClick: this.handleOpenOnlineBooking.bind(this, row) },
                                ]} />
                            </TableCell>
                        </TableRow>
                    ))}
                </PhoneClinicGrid>
                <JobForm
                    shopId={this.ownId()}
                    openModal={this.state.openModal}
                    closeModal={this.handleClose.bind(this)}
                    eligibleFor={this.state.eligibleFor}
                    jobData={this.state.filteredListData}
                />
            </div>
        );
    }
}

export default JobRequest;